import { Dispatch, ReactNode, useCallback } from 'react';
import { useBreakpoints } from '../../../../../../bookings/util/useBreakpoints';
import { LinkTrackingData } from '../../../../../AnalyticsContext/LinkTracking';
import { SingleViewSearchCategory } from '../SingleViewSearchCategory';
import {
  SingleViewSuggestionHeader,
  SuggestionHeaderLabel,
  SuggestionCategoriesContainer,
  CategoryView,
  CategoryLabel,
  ListContainer,
  BackToAll,
  StyledBackArrow,
  SearchFooter,
} from './SuggestionsLayoutTemplate.styles';

interface Props {
  suggestionList?: ReactNode;
  suggestionType: string;
  toggleSingleSuggestionView: Dispatch<SingleViewSearchCategory>;
  trackingData: LinkTrackingData;
  pluraliseType: string;
  footer?: ReactNode;
}

export const SingleSuggestionsLayoutTemplate = ({
  suggestionList,
  suggestionType,
  toggleSingleSuggestionView,
  pluraliseType,
  footer,
}: Props) => {
  const showSingleViewSuggestion = useCallback(
    () =>
      toggleSingleSuggestionView({
        showSingleView: false,
      }),
    [toggleSingleSuggestionView],
  );

  const isMobile = useBreakpoints().Small;

  return (
    <>
      <SingleViewSuggestionHeader>
        <BackToAll onClick={showSingleViewSuggestion}>
          <StyledBackArrow />
          Back to all categories
        </BackToAll>
      </SingleViewSuggestionHeader>
      <SuggestionCategoriesContainer>
        <CategoryView>
          <SuggestionHeaderLabel>Select a {suggestionType}.</SuggestionHeaderLabel>
          <CategoryLabel>{pluraliseType}</CategoryLabel>
          <ListContainer>{suggestionList}</ListContainer>
          {isMobile && <SearchFooter>{footer}</SearchFooter>}
        </CategoryView>
      </SuggestionCategoriesContainer>
    </>
  );
};
